import React, { useEffect } from "react";
import ReactDOM from "react-dom";
import { BrowserRouter, Route, Switch, Redirect } from "react-router-dom";

import "@fortawesome/fontawesome-free/css/all.min.css";
import "assets/styles/tailwind.css";

// layouts

import Admin from "layouts/Admin.js";
import { Provider, useDispatch } from "react-redux";
import { store } from "store/store";
import Login from "views/Login";
import { setupAutoLogout } from "utils/setupAutoLogout";
import { logout } from "store/authSlice";

function AppWrapper() {
  const dispatch = useDispatch();

  useEffect(() => {
    const token = localStorage.getItem("token");
    setupAutoLogout(token, () => {
      dispatch(logout());
      window.location.href = "/login"; 
    });
  }, [dispatch]);


 return (
    <BrowserRouter>
      <Switch>
        <Route path="/admin" component={Admin} />
        <Route path="/login" component={Login} />
        <Redirect from="/" to="/login" />
      </Switch>
    </BrowserRouter>
  );
}

ReactDOM.render(
  <Provider store={store}>
    <AppWrapper />
  </Provider>,
  document.getElementById("root")
);

// ReactDOM.render(
//   <Provider store={store}>
//   <BrowserRouter>
//     <Switch>
//       <Route path="/admin" component={Admin} />
//       <Route path="/login" component={Login} />
//       <Redirect from="/" to="/login" />
//     </Switch>
//   </BrowserRouter>
//   </Provider>,
//   document.getElementById("root")
// );
